import React from 'react';
import { TileHead } from '../TileHead';

const BOSSOutOfStock = () => {
  return (
    <div className="fulfillment-tile">
      <TileHead title="Ship to Store" />
      <div className="fulfillment__sub-title">Out of stock</div>
    </div>
  );
};

BOSSOutOfStock.propTypes = {
};

BOSSOutOfStock.defaultProps = {
};

export { BOSSOutOfStock };
